module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ourTeam"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical"
  }, [_c('div', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Burçak Sercan Sarıkaya")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sarikaya@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle2
    }
  }, [_vm._v("Onur Şahin")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("sahin@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive2
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle2
    }
  })])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle3
    }
  }, [_vm._v("Ali Rıza Aksoy")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("aksoy@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive3
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle3
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle4
    }
  }, [_vm._v("Halil Çolak")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("colak@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive4
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle4
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle5
    }
  }, [_vm._v("Hüseyin Alp İlker")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("ilker@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive5
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle5
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle7
    }
  }, [_vm._v("Rafet Emin Demir")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("demir@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive7
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle7
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle8
    }
  }, [_vm._v("Uğur Fırtına")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("firtina@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive8
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle8
    }
  })])])])])]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "tile colums"
  }, [_c('div', {
    staticClass: "column is-half paddingless"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4",
    on: {
      "click": _vm.toggle6
    }
  }, [_vm._v("Onur Uraz")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("uraz@sarikayasahin.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.isActive6
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.toggle6
    }
  })])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-3 is-vertical"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "deneme"
  }, [_vm._v("EKİBİMİZ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("KURUCU ORTAKLAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/burcakSarikaya.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Burçak Sercan Sarıkaya")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Atılım Üniversitesi Sosyal Bilimler Enstitüsü (İşletme Doktora Programı – Tam Burslu, devam etmekte)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Bahçeşehir Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı – Tam Burslu)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("ELSA")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onurSahin.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Şahin")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Doktora Programı, devam etmekte)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                                                                            Glasgow Üniversitesi Hukuk Fakültesi (Fikri Mülkiyet ve Dijital Ekonomi Tezli Yüksek Lisans Programı – Avrupa Birliği Jean Monnet Bursu ile)\n                                                                        ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")]), _vm._v(" "), _c('li', [_vm._v("Passau Üniversitesi Hukuk Fakültesi ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Marka Vekili ")]), _vm._v(" "), _c('li', [_vm._v("Patent Vekili ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Yabancı Dil")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")]), _vm._v(" "), _c('li', [_vm._v("Almanca")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("AVUKATLAR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/aliRiza.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Ali Rıza Aksoy")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("ELSA")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/halil.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Halil Çolak")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/alp.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Hüseyin Alp İlker")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı) ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/rafet.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Rafet Emin Demir")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı) ")]), _vm._v(" "), _c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/ugur.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Uğur Fırtına ")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankara Üniversitesi Hukuk Fakültesi (Lisans) ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-child  has-text-right is-size-1"
  }, [_c('h2', [_vm._v("DANIŞMAN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "contianer"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('img', {
    attrs: {
      "src": "/static/onur.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Onur Uraz")]), _c('br'), _vm._v(" "), _c('h3', [_vm._v("EĞİTİM")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Southampton Üniversitesi (Uluslararası Ceza Hukuku Doktora Programı)")]), _vm._v(" "), _c('li', [_vm._v("Glasgow Üniversitesi (Ululararası Kamu Hukuku Yüksek Lisans Programı)")]), _vm._v(" "), _c('li', [_vm._v("Gazi Üniversitesi Hukuk Fakültesi (Lisans)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("ÜYELİKLER")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Southampton Student Law Review Editörü (2017)")]), _vm._v(" "), _c('li', [_vm._v("Ankara Barosu Dergisi Yürütme Kurulu Üyesi (2012)")]), _vm._v(" "), _c('li', [_vm._v("International Association of Genocide Scholars ")]), _vm._v(" "), _c('li', [_vm._v("European Society of International Law")]), _vm._v(" "), _c('li', [_vm._v("The Centre for Law, Policy and Society (Southampton University)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("YABANCI DİL")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("İngilizce")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f4e5f4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ekip.vue
// module id = 171
// module chunks = 0